import { useInterval } from '@proton/components/hooks/useHandler';
import { serverTime } from '@protontech/crypto';

import { isExpired } from '../helpers/expiration';

import { EXPIRATION_CHECK_FREQUENCY } from '../constants';
import type { Element } from '../models/element';

export const useExpirationCheck = (elements: Element[], expiredCallback: (elements: Element[]) => void) => {
    useInterval(EXPIRATION_CHECK_FREQUENCY, () => {
        const nowTimestamp = +serverTime();
        expiredCallback(
            elements.filter((element) => {
                return isExpired(element, nowTimestamp);
            })
        );
    });
};
